import removeURLSearchParam from "./removeURLSearchParam"

export default function extractURLSearchParam(name: string, removeParam: boolean = true) {
    const urlParams = new URLSearchParams(window.location.search)
    const value = urlParams.get(name)

    // If a value was extracted, remove it from the url and return it
    if (value !== null) {
        if (removeParam) {
            removeURLSearchParam(name)
        }

        return decodeURIComponent(value)
    }
}
